/* RESPONSIBLE TEAM: team-automation-foundations */
import ConditionalBranchesConfiguration from './conditional-branches';
import { type StepConfigParams } from '../step';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';
import type ResolutionRules from 'embercom/models/operator/visual-builder/step/resolution-rules';

export default class ResolutionRulesConfiguration extends ConditionalBranchesConfiguration {
  declare step: ResolutionRules;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/resolution-rules',
      ...params,
    } as StepConfigParams);
  }

  deleteBranch(branch: ConnectionPoint) {
    this.intercomEventService.trackAnalyticsEvent({ object: branch, action: 'removed' });
    this.branches.removeObject(branch);
    this.editorState.logInteraction('Deleted resolution rule branch');
  }
}
